//
// Site JS
//

// Remove preload class (class stops CSS animations flash)
window.onload = function () {
	document.body.classList.remove('preload');
};

// Mobile navigation
var toggle = document.querySelector('#nav-toggle');
var overlay = document.querySelector('#nav-overlay');
var body = document.querySelector('body');
toggle.onclick = function() {
  toggle.classList.toggle('active');
  overlay.classList.toggle('open');
  body.classList.toggle('noScroll');
}

// Main navigation (headroom.js)
var header = document.querySelector("header");
var headerHeadroom  = new Headroom(header, {
  "offset": 50,
  "tolerance": 0,
  "classes": {
    initial : "header",
    pinned : "header--pinned",
    unpinned : "header--unpinned",
    top : "header--top",
    notTop : "header--not-top",
    bottom : "header--bottom",
    notBottom : "header--not-bottom",
    frozen: "header--frozen",
  },
});
headerHeadroom.init();

// Booking buttons (headroom.js)
var bookingButtons = document.querySelector('.booking-buttons');
var bookingHeadroom = new Headroom(bookingButtons, {
  "offset": 0,
  "tolerance": 0,
  "classes": {
    initial : "booking-buttons",
    pinned : "booking-buttons--pinned",
    unpinned : "booking-buttons--unpinned",
    top : "booking-buttons--top",
    notTop : "booking-buttons--not-top",
    bottom : "booking-buttons--bottom",
    notBottom : "booking-buttons--not-bottom",
    frozen: "booking-buttons--frozen",
  },
});
bookingHeadroom.init();

// Lazy loading (lazysizes.js)
var lazy = function lazy() {
  document.addEventListener('lazyloaded', function (e)  {
    e.target.parentNode.classList.add('image-loaded');
    e.target.parentNode.classList.remove('loading');
  });
}
lazy();

// Cookie notice (cookieconsent.js)
window.addEventListener("load", function () {
  window.cookieconsent.initialise({
    "palette": {
    "popup": {
    "background": "rgba(12,7,15,.6)",
    "text": "white"
  },
    "button": {
      "background": "#191227",
      "text": "#ffffff"
    }
  },
    "position": "bottom-right",
    "content": {
      "message": "We use cookies to display this website.",
      "dismiss": "Dismiss",
      "link": "To learn more see our privacy policy",
      "href": "{{ url('privacy-policy') }}"
    }
  })
});